import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import ErrorNavigationButtons from '@Components/Error/ErrorNavigationButtons';

const ErrorView = (props) => {
    return (
        <div className='fluid border row large-4 medium-10 error-content-container error-index'>
            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            <div className='inner-wrap columns large-12'>
                <div className='pad-tb large-12 medium-12 small-11'>
                    <h1 className='pagename border-bottom'><TranslationText tKey='sandhills.weresorry' />...</h1>
                    <p>
                        <span className='font18 error'><TranslationText tKey='sandhills.tradesites.mvc.wecouldntfindthatpage' /></span>
                    </p>
                    <ErrorNavigationButtons {...props} />
                    <p>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.apologizeforinconvenience' />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ErrorView;
global.ErrorView = ErrorView;